import { observer } from "mobx-react-lite";
import styles from "./Permissions.module.css";
import { userStore } from "@/stores/UserStore";

export const TypeUser = observer(() => {
  return (
    <div className={styles.iterationPermissions}>
      <div className={styles.titleSection}>
        <span>Тип учетной записи:</span>
        <p role-id={userStore.role}>{userStore.roleName}</p>
      </div>
    </div>
  );
});
